export var TITLE = 'Gemini';
export var TEXT_MULTIPLE = 0.8;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#1C69FF';
export var COLOR_GRADIENT = 'linear-gradient(45deg, #1C69FF 40%,  #F0DCD6 100%)';